import {useCallback, useEffect} from "react";
import {batch, useSignal, useComputed, useSignalEffect} from "@preact/signals-react";
import {useToastSeeker} from "@ui-seeker/app";
import {postSubmit} from "@ui-seeker/utils";

import {commonFiltersValue, isLoadingCommonFilters} from "@signals";
import {isLoadingKpi, isLoadingMetric, isLoadingEvo} from "../@signals";
import {BACKEND_APIS, DATE_METRICS} from "@constants";


export default function useUserActivityEvolution() {
	const { showToast } = useToastSeeker()
	const data = useSignal([])
	const isLoadingFilters = useSignal(false)
	const kpi = useSignal('users')

	useEffect(() => {
        isLoadingEvo.value = isLoadingFilters.value;
    }, [isLoadingFilters.value]);

	useEffect(() => {
		if (isLoadingCommonFilters.value || isLoadingMetric.value || isLoadingKpi.value) batch(() => {
		    isLoadingFilters.value = true
			data.value = []
			postSubmit(`${BACKEND_APIS.ADMIN}/user-activities/evolution/${kpi}`, { ...commonFiltersValue.value }).then(res => {
				if (!res.data?.length) {
					isLoadingCommonFilters.value = false
				}
				data.value = res.data
			}).catch(() => {
				showToast.error()
			})
			.finally(() => {
                isLoadingKpi.value = false
                isLoadingMetric.value = false
                isLoadingFilters.value = false
            })
		})
	}, [
        isLoadingCommonFilters.value,
        isLoadingMetric.value,
        isLoadingKpi.value
	]);

	const handleChangeKpi = useCallback(e => {
		kpi.value = e.target.value
		isLoadingKpi.value = true
	}, [isLoadingKpi.value])

	return {
		evoData: data.value,
		isLoadingEvo: isLoadingFilters.value,
		kpi: kpi.value,

		handleChangeKpi
	}
}